import { Button, Popover } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface button {
  onClick: any;
  disabled?: boolean;
}

const DeleteButton = ({ onClick, disabled }: button) => {
  const [t] = useTranslation("common");
  const iconColor = !disabled ? "#F5222D" : 'gray'
  const content = <div>{t("delete")}</div>;

  return (
    <>
      <Popover content={content} mouseEnterDelay={0} mouseLeaveDelay={0}>
        <Button
          disabled={disabled}
          className="Button"
          type="text"
          icon={<DeleteOutlined style={{ fontSize: "14px", color: iconColor }} />}
          onClick={onClick}
          size="small"
        />
      </Popover>
    </>
  );
};

export default DeleteButton;